import { Howl, Howler } from "howler";
import ambient from "../assets/sounds/diorbystarck-audio.mp3";

class AudioManager {
  constructor() {
    this.audioActivated = false;
    this.ambient = new Howl({
      src: ambient,
      loop: true,
      volume: 0,
      autoplay: false,
    });
  }

  play() {
    this.ambient.play();
    this.audioActivated = true;
    this.ambient.fade(0, 1, 500);
  }

  onClickVolumeBtn(newVolume) {
    this.ambient.fade(this.ambient.volume(), newVolume, 500);
  }
}

const manager = new AudioManager();
export default manager;
